module.exports = __webpack_public_path__ + "static/media/bannerBg.6f1e9fa3.png";